import React, { Component } from 'react';
import { post } from '../Services/http';
import LoadingButton from '../Components/LoadingButton'
import { translate } from '../Services/translation';

class ChangePasswordByToken extends Component {
    constructor(props) {
        super(props);
        this.state = this.getInitialState();
    }

    getInitialState() {
        return {
            firstPassword: this.props.haspresetpassword === "True" ? "presetPassword_notUsed" : "",
            secondPassword: this.props.haspresetpassword === "True" ? "presetPassword_notUsed" : "",
            redirecturl: this.props.redirecturl,
            isLoading: false,
            isCompleted: false,
            isError: false,
            errorCode: "",
            passwordsNotValid: false
        };
    }

    reset(loadingInterval) {
        this.setState(this.getInitialState());
        clearInterval(loadingInterval);
    }

    onSuccess() {
        this.setState({...this.getInitialState(), isCompleted: true})
         if (this.state.redirecturl) {
             setTimeout(() => {
                 window.location.href = this.state.redirecturl;
             }, 2000);
         }
    }

    onError(ex) {
        const loadingInterval = setInterval(() => this.reset(loadingInterval), 3000);
        
        if (ex.response.status === 400) {
            ex.response.json()
            .then(result => {
                this.setState({...this.getInitialState(), isError: true, errorCode: result.message});
            })
            return;
        }

        this.setState({...this.getInitialState(), isError: true, errorCode: 'genericerror'});
    }

    verifyPasswordInput(invalidPasswords) {
        this.setState({ passwordsNotValid: invalidPasswords });
        return !invalidPasswords;
    }

    bothPasswordsEmpty() {
        return this.state.firstPassword === "" && this.state.secondPassword === "";
    }

    passwordsNotEqual() {
        return this.state.firstPassword !== this.state.secondPassword;
    }

    onInputChanged(event) {
        this.setState({ [event.target.name]: event.target.value }, 
            () => this.verifyPasswordInput(this.passwordsNotEqual()))
    }

    onSubmit() {
        if (!this.verifyPasswordInput(this.bothPasswordsEmpty() || this.passwordsNotEqual())) {
            return;
        }

        this.setState({ isLoading: true});
        
        post('/api/user/changepassword', { ResetPasswordToken: this.props.token, NewPassword: this.state.firstPassword })
        .then(() => this.onSuccess())
        .catch(ex => this.onError(ex));
    }

    render() {
        const title = this.props.title;

        const headerStyle = {
            'margin-bottom': '2rem'
        }
        
        const loginLinkStyle = {
            'margin-top': '1.5rem'
        }

        const errorStyle = {
            'margin-bottom': '0.5rem',
            'height': '1rem'
        }

        const inputStyle = {
            'margin': '0'
        }

        const buttonStyle = {
            width: '100%'
        }

        return(
            <div className="full-height">
                {title && (<div className="row" style={headerStyle}>
                    <div className="columns"><span className="text-center"><h4>{title}</h4></span></div>
                </div>)}
                <div className="row">
                    <div className="columns small-12 medium-expand"/>
                    <div className="columns small-12 medium-expand">
                        <input className={`form__input ${this.state.passwordsNotValid ? "invalidinput" : ""}`} 
                            placeholder={translate('changepassword.newpassword')}
                            disabled={this.state.isCompleted || this.props.haspresetpassword === "True"}
                            id="firstPassword" name="firstPassword" type="password"
                            onChange={(event) => this.onInputChanged(event)} value={this.state.firstPassword || ''}/>

                        <input className={`form__input ${this.state.passwordsNotValid ? "invalidinput" : ""}`}
                            placeholder={translate('changepassword.confirmpassword')}
                            style={inputStyle}
                            disabled={this.state.isCompleted || this.props.haspresetpassword === "True"}
                            id="secondPassword" name="secondPassword" type="password"
                            onChange={(event) => this.onInputChanged(event)} value={this.state.secondPassword || ''}/>
                        
                        <span id="error" style={errorStyle} className="form__validator--error">
                            { (this.state.isError && translate(`changepassword.${this.state.errorCode}`)) 
                            || (this.state.passwordsNotValid && translate('changepassword.invalidinput'))}
                        </span>

                        <LoadingButton onClick={() => this.onSubmit(this.state.email)}
                            style = {buttonStyle}
                            submitText={translate('changepassword.submit')} 
                            errorText={translate('changepassword.error')} 
                            successText={translate('changepassword.success')}
                            isLoading={this.state.isLoading} isCompleted={this.state.isCompleted} isError={this.state.isError}/>
                    </div>
                    <div className="columns small-12 medium-expand"/>
                </div>
            </div>
        );
    }

}

export default ChangePasswordByToken;
